import { useDispatch } from "react-redux";
import { logout, setLogin } from "../../redux/items/LoginReducer";
import FetchNoLogin from "./FetchNoLogin";

const FetchLogin = (url, v2 = {}) => {
  const dispatch = useDispatch();
  const callback2 = false || v2.callback;

  v2.callback = (cb) => {
    // console.log(cb.response.data);
    if (cb.response.data?.user !== undefined) {
      cb.response.data.user.user.credits = parseFloat(
        cb.response.data.user.user.credits
      ).toFixed(2);
      dispatch(setLogin(cb.response.data.user));
    } else {
      // dispatch(logout());
    }

    if (
      cb.response.message === "invalid token"
      // || cb.response.message === "token is required"
    ) {
      dispatch(logout());
      window.location.href = "/";
    } else if (callback2) callback2(cb);
  };

  return FetchNoLogin(url, v2);
};

export default FetchLogin;
